import React, {useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import {logOut} from "../../redux/dataUploader/dataSlice";
import Loader from "../../components/loaders/Loader";
import MessageSendingData from "../../components/popups/MessageSendingData";
import Select from "react-select";
import {Link} from "react-router-dom";

import './voluum-kelkoo-integration.scss';

const VoluumKelkooIntegration = () => {

  const token = localStorage.getItem("auth_token");
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(1);
  const [campaignID, setCampaignID] = useState('');
  const [serviceID, setServiceID] = useState('');
  const [validationError, setValidationError] = useState(false);
  const [validationErrorMessage, setValidationErrorMessage] = useState('');
  const [downloadFileUrl, setDownloadFileUrl] = useState(null);
  const [fileError, setFileError] = useState(false);
  const [fileErrorMessage, setFileErrorMessage] = useState(null);
  const [serviceIDError, setServiceIDError] = useState(false);
  const [serviceIDErrorMessage, setServiceIDErrorMessage] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState({
      id: localStorage.getItem("id"),
      name: localStorage.getItem("name"),
  });
  const [anAccounts, setAnAccounts] = useState([]);
  const [selectedANType, setSelectedANType] = useState({value: 'voluum', label: 'voluum'});
  const [selectedANAccount, setSelectedANAccount] = useState(null);
  const [anTypes, setAnTypes] = useState([]);
  const [restData, setRestData] = useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [confirmationPopupText, setConfirmationPopupText] = useState("");
  
  const [userToken, setUserToken] = useState('');
  const [workspaceID, setWorkspaceID] = useState('');
  const [affiliateNetworkID, setAffiliateNetworkID] = useState('');
  const [userEmail, setUserEmail] = useState(localStorage.getItem('email') || '');
  const [campagnLink, setCampagnLink] = useState('');
  const [permanentLinkID, setPermanentLinkID] = useState('');
  const [downloadCompaneSuccessMessage, setDownloadCompaneSuccessMessage] = useState('');

  const checkSession = (status) => {
      if(status === 401) {
          dispatch(logOut());
      }
  }

  const selectStyles = {
    container: (baseStyles) => ({
        ...baseStyles,
        maxWidth: "180px",
        width: "100%",
        margin: "0 20px 0 0",
    }),
    control: (baseStyles, state) => ({
        ...baseStyles,
        fontSize: "14px",
        lineHeight: "1.2",
        minHeight: "26px",
        border: "none",
        borderRadius: "8px",
        "&:hover": {
            cursor: "pointer",
        },
    }),
    placeholder: (baseStyles) => ({
        ...baseStyles,
        fontWeight: 500,
        color: "#1A3353",
    }),
    menu: (baseStyles, state) => ({
        ...baseStyles,
        zIndex: "6",
        "&:hover": {
            cursor: "pointer",
        },
    }),
    option: (baseStyles, state) => ({
        ...baseStyles,
        fontSize: "14px",
        lineHeight: "1.2",
        "&:hover": {
            cursor: "pointer",
        },
    }),
  }

  useEffect(() => {
      setIsLoading(true);

      // initial fetch
      fetch(`${localStorage.getItem("apiUrl")}api/user/${selectedUser.id}/services?status=true&is_archived=false`, {
          headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
          },
      })
          .then(res => {
              checkSession(res.status);
              if (res.ok) {
                  return res.json()
              }
              return Promise.reject(res)
          })
          .then(res => {

              setSelectedUser({id: res.id, name: res.name})
              
              if(res.id === 57) {
                setCampagnLink('https://rainbowsoffers.com/rainonrf?nrf=');
                setPermanentLinkID('b35bbd8d-340f-4917-9402-9151c9704482');
              } else {
                setCampagnLink('');
                setPermanentLinkID('');
              }

              setUsersList([...res["user_managers_accounts"]])
              setAnTypes([])
              setAnAccounts([])
              if (res["user_services"] && res["user_services"].length > 0) {
                  let temp = []
                  let types = [] // for unique types
                  res["user_services"].forEach(item => {
                      if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name === "voluum" && item?.status === true) {
                          types.push(item?.types?.name)
                          temp.push({value: item?.types?.name, label: item?.types?.name})
                      }
                  })
                  setAnTypes(temp)
              }
              
              if(usersList.length === 0) {
                let tempB = [];
                
                tempB = res["user_services"].filter(item => item?.types?.name === 'voluum' && item?.status === true)
                tempB = tempB.reduce((acc, item) => {
                    acc.push({value: item.id, label: item.name})
                    return acc
                }, [])

                setAnAccounts(tempB)
                setSelectedANAccount(tempB[0]?.value || null);
              }

              setRestData(res)
              setIsLoading(false)
          })
          .catch(res => {
            setIsLoading(false)
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
          })
  }, []);

  const handleChangeSelectedUser = (user) => {
    setIsLoading(true);
    setSelectedANAccount(null);
    setFileError(false);
    setFileErrorMessage(null);
    setServiceIDError(false);
    setServiceIDErrorMessage(null);
    setValidationError(false);
    setValidationErrorMessage('');
    setDownloadFileUrl(null);
    setUploadedFile(null);
    setCampaignID('');
    setDownloadCompaneSuccessMessage('');
    setUserToken('');
    setWorkspaceID('');
    setAffiliateNetworkID('');
    setServiceID('');
    setServiceIDError(false);

    // fetch user services
    fetch(`${localStorage.getItem("apiUrl")}api/user/${user.value}/services?status=true&is_archived=false`, {
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`

        },
    })
        .then(res => {
            checkSession(res.status);
            if (res.ok) {
                return res.json()
            }
            return Promise.reject(res)
        })
        .then(res => {
            setSelectedUser({
                id: res.id,
                name: res.name
            })
            
            if(res.id === 57) {
              setCampagnLink('https://rainbowsoffers.com/rainonrf?nrf=');
              setPermanentLinkID('b35bbd8d-340f-4917-9402-9151c9704482');
            } else {
              setCampagnLink('');
              setPermanentLinkID('');
            }
            
            setAnTypes([])
            setAnAccounts([])
            if (res["user_services"] && res["user_services"].length > 0) {
                let temp = []
                let types = [] // for unique types
                res["user_services"].forEach(item => {
                    if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name === "voluum" && item?.status === true) {
                      types.push(item?.types?.name);
                      temp.push({value: item?.types?.name, label: item?.types?.name});
                    }
                })
                setAnTypes(temp);

                let tempB = []
                tempB = res["user_services"].filter(item => item?.types?.name === 'voluum' && item?.status === true)
                tempB = tempB.reduce((acc, item) => {
                    acc.push({value: item.id, label: item.name})
                    return acc
                }, [])
                if (tempB.length === 1) {
                  setSelectedANAccount(tempB[0].value);
                } else {
                  setSelectedANAccount(null);
                }

                setAnAccounts(tempB)
            }

            setRestData(res)
            setIsLoading(false);
        })
        .catch(res => {
            setIsLoading(false)
            setConfirmationPopupText("Something went wrong")
            setShowConfirmationPopup(true)
        })
  }

  const handleChangeANAccount = async (option) => {
    setSelectedANAccount(option.value);
  };

  const changeCampaignFormSubmit = async (e) => {
    e.preventDefault();

    setValidationError(false);
    setValidationErrorMessage('');

    if(userToken.length !== 0 && 
      workspaceID.length !== 0 && 
      affiliateNetworkID.length !== 0 && 
      userEmail.length !== 0 && 
      campagnLink.length !== 0 && 
      permanentLinkID.length !== 0) {
      setValidationError(true);
      setValidationErrorMessage('');
      
      const data = JSON.stringify({
        "token": userToken,
        "workspace_id": workspaceID,
        "affiliate_network_id": affiliateNetworkID,
        "email": userEmail,
        "link": campagnLink,
        "permanent_link_id": permanentLinkID
      })

      setFormLoading(true);
      
      try {
        const response = await fetch(`${localStorage.getItem('apiUrl')}api/voluum/prepared-kelkoo-offers`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          method: 'POST',
          body: data
        });

        checkSession(response.status);

        const result = await response.json();

        if (response.ok) {
          setDownloadCompaneSuccessMessage(result.message);
          setTimeout(() => {
            setDownloadCompaneSuccessMessage('');
          }, 5000);
          setUserToken('');
          setWorkspaceID('');
          setAffiliateNetworkID('');
          if(selectedUser.id !== 57) {
            setCampagnLink('');
            setPermanentLinkID('');
          }
        } else {
          
          let errorMsg;

          try {

            const parsedArray = JSON.parse(result.errors.message);
            let jsonString = parsedArray[0].replace("Error:", "").trim();
            let errorObj = JSON.parse(jsonString);

            if (Array.isArray(errorObj)) {
              errorMsg = `Error: ${errorObj[0]}`;
            } else if (typeof errorObj === "object" && errorObj !== null) {
              errorMsg = `Error: ${errorObj.code} - ${errorObj.description}`;
            } else {
              console.log('oops - unexpected format of error in responce');
            }

          } catch (error) {
            errorMsg = result.errors.message;
          }

          setValidationError(true);
          setValidationErrorMessage(errorMsg);
        }
      } catch (error) {
        console.error(error.message);
      }
      setFormLoading(false);
    } else {
      setValidationError(true);
      setDownloadFileUrl(null);
      setValidationErrorMessage('All fields are required');
    }
  }

  const checkServiceId = (e) => {
    const id = e.target.value;
    setServiceID(id);
    if(serviceID.length !== 0) {
      setServiceIDError(false);
      setServiceIDErrorMessage('');
    }
  }

  const fileUploaded = (e) => {
    setFormLoading(true);
  
    const file = e.target.files[0];
        
    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const allowedExtensions = ['xlsx', 'xls', 'csv'];
      if (!allowedExtensions.includes(fileExtension)) {
        setFileError(true);
        setFileErrorMessage(['Only .csv, .xls, .xlsx files are allowed.']);
        setUploadedFile(null);
      } else {
        setFileError(false);
        setFileErrorMessage(null);
        setUploadedFile(file);
      }
    } else {
      setFileError(true);
      setFileErrorMessage(['No file selected. Please upload a file.']);
      setUploadedFile(null);
    }

    setFormLoading(false);
  };

  const sendFile = async () => {
    if (!uploadedFile) {
      setFileError(true);
      setFileErrorMessage(['No file selected. Please upload a file.']);
      return;
    }

    if (serviceID.length === 0) {
      setServiceIDError(true);
      setServiceIDErrorMessage('Please enter a valid Campaign ID');
      return;
    }

    setFormLoading(true);
    setSuccessMessage('');
    let cleanedServiceID;
    cleanedServiceID = serviceID.replaceAll(' ', '');
    cleanedServiceID = cleanedServiceID.replace(/,+$/, '');
    const formData = new FormData();
    
    try {
      if (uploadedFile && serviceID) {
        formData.append('campaign_file', uploadedFile);
        formData.append('campaign_ids', cleanedServiceID);
      } else {
        throw new Error('Uploaded file is invalid or missing.');
      }

      const response = await fetch(`${localStorage.getItem('apiUrl')}api/voluum/campaigns-management-upload-simple/${selectedANAccount}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      checkSession(response.status);

      const result = await response.json();

      if (!response.ok) {
        setFileError(true);
        let errorMsg;

        try {
          const parsedArray = JSON.parse(result.errors.message);
          
          if (Array.isArray(parsedArray)) {
            let errorsArray;

            if(parsedArray[0].includes("Error:")) {
              let trimError = parsedArray[0].replace("Error:", "").trim();
              errorsArray = JSON.parse(trimError);
            } else {
              errorsArray = parsedArray;
            }

            setFileErrorMessage(errorsArray);
            setFormLoading(false);
            return;

          } else { 
            let jsonString = parsedArray.replace("Error:", "").trim();
            let errorObj = JSON.parse(jsonString);
            
            if (Array.isArray(errorObj)) {
              errorMsg = `Error: ${errorObj[0]}`;
            } else if (typeof errorObj === "object" && errorObj !== null) {
              errorMsg = `${errorObj.code} - ${errorObj.description}. ${errorObj.messages[0] ? `Message: ${errorObj.messages[0]}` : ""}`;
            } else {
              console.log('oops - unexpected format of error in responce');
            }
          }
        } catch (error) {
          errorMsg = result.errors.message;
        }

        setFileErrorMessage([errorMsg] || ['Failed to upload file. Please try again.']);
        setFormLoading(false);
        return;
      }

      setFileError(false);
      setFileErrorMessage(null);
      setSuccessMessage(result.message);
      setUploadedFile(null);
    } catch (error) {
      console.error('Error uploading file:', error.message);
      setFileError(true);
      setFileErrorMessage(['Failed to upload file. Please try again.']);
    }

    setFormLoading(false);
  };

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
    if (tab === 2) {
      setCampaignID(''); 
    }

    setFileError(false);
    setFileErrorMessage(null);
    setServiceIDError(false);
    setServiceIDErrorMessage(null);
    setServiceID('');
    setValidationError(false);
    setValidationErrorMessage('');
    setDownloadFileUrl(null);
    setUploadedFile(null);
    setDownloadCompaneSuccessMessage('');
    setUserToken('');
    setWorkspaceID('');
    setAffiliateNetworkID('');
  };

  if (isLoading) {
    return <div className='loading-wrap'><Loader/></div>
  }

  return (
      <>
        <div className={`changed-campaigns-container`}>
          <div style={{
              display: "flex",
              alignItems: "center",
              margin: "0 0 10px",
          }}>

              <Select
                  className={""}
                  styles={selectStyles}
                  options={usersList.length !== 0 ? usersList
                      .slice()
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .reduce((acc, item) => {
                      acc.push({value: item.id, label: item.name})
                      return acc
                  }, []) : [{value: selectedUser.id, label: selectedUser.name}]}
                  isSearchable={true}
                  defaultValue={{value: selectedUser.id, label: selectedUser.name}}
                  name={"user"}
                  placeholder={"User"}
                  components={{
                      IndicatorSeparator: () => null
                  }}
                  onChange={(option) => handleChangeSelectedUser(option)}
              />

              <Select
                  className={""}
                  styles={selectStyles}
                  options={anAccounts
                      .slice()
                      .sort((a, b) => a.label.localeCompare(b.label))
                  }
                  isSearchable={true}
                  defaultValue={selectedANAccount}
                  name={"affiliate_network_account"}
                  placeholder={anAccounts.length === 1 ? anAccounts[0].label : "Voluum account"}
                  components={{
                      IndicatorSeparator: () => null
                  }}
                  onChange={(option) => handleChangeANAccount(option)}
              />

          </div>
        </div>
        { selectedANAccount && !formLoading ? (
          <div>
            <div className="tabsContainer">
              <div
                onClick={() => handleTabSwitch(1)}
                className={activeTab === 1 ? 'activeTab' : 'inactiveTab'}
              >
                Generate the Kelkoo offers file
              </div>
              <div
                onClick={() => handleTabSwitch(2)}
                className={activeTab === 2 ? 'activeTab' : 'inactiveTab'}
              >
                Update Existing Campaign
              </div>
            </div>

            {/* Tab Content */}
            <div className="contentContainer">
              {activeTab === 1 ? (
                <div>
                  <p>Enter the needed Voluum and Kelkoo parameters:</p>
                  <form className="compaign-form">
                    <label htmlFor="token">Your Token</label>
                    <input type="text" id="token" name="token" onChange={(e) => {setUserToken(e.target.value)}} value={userToken || ''} />
                    <label htmlFor="workspaceID">Workspace ID</label>
                    <input type="text" id="workspaceID" name="workspaceID" onChange={(e) => {setWorkspaceID(e.target.value)}} value={workspaceID || ''} />
                    <label htmlFor="affiliateNetworkID">Affiliate Network ID</label>
                    <input type="text" id="affiliateNetworkID" name="affiliateNetworkID" onChange={(e) => {setAffiliateNetworkID(e.target.value)}} value={affiliateNetworkID || ''} />
                    <label htmlFor="userEmail">Email</label>
                    <input type="text" id="userEmail" name="userEmail" onChange={(e) => {setUserEmail(e.target.value)}} value={userEmail || ''} />
                    <label htmlFor="campagnLink">Link</label>
                    <input type="text" id="campagnLink" name="campagnLink" onChange={(e) => {setCampagnLink(e.target.value)}} value={campagnLink || ''} />
                    <label htmlFor="permanentLinkID">Permanent Link ID</label>
                    <input type="text" id="permanentLinkID" name="permanentLinkID" onChange={(e) => {setPermanentLinkID(e.target.value)}} value={permanentLinkID || ''} />
                    
                    <input type="submit" className="blue-btn" onClick={changeCampaignFormSubmit} value="Submit" />
                    {validationError ? <p className="error">{validationErrorMessage}</p> : ''}
                  </form>
                  {downloadCompaneSuccessMessage ? (
                    <>
                      <p className="success-message">{downloadCompaneSuccessMessage}</p> 
                    </>
                  ) : '' }
                </div>
              ) : (
                <div>
                  <p>Update a campaign by uploading a file with the new configurations.</p>

                  <form
                    className="file-upload"
                    onSubmit={(e) => {
                      e.preventDefault();
                      sendFile();
                    }}
                  >
                    <p>Campaign IDs</p>
                    <p><span>Enter campaign ids separated by coma without spaces (ex: 123,456,789)</span></p>
                    <input 
                      type="text"
                      onChange={checkServiceId}
                      value={serviceID || ''}
                      className="service-id-input"
                    />
                    <p className="error">{serviceIDErrorMessage}</p>
                    <p className="file-input-title">Upload .csv, .xls or .xlsx file:</p>
                    <input
                      type="file"
                      onChange={fileUploaded}
                      className="file-input"
                    />

                    {fileError && Array.isArray(fileErrorMessage) && fileErrorMessage.map((item, index) => {
                      return <p className="error" key={index}>{item}</p> 
                    })
                    }
                    {fileError && !Array.isArray(fileErrorMessage) ? <p className="error">{JSON.stringify(fileErrorMessage)}</p> : ''}
                    
                    {successMessage && <p className="success">{successMessage}</p>}
                    <button
                      disabled={fileError || uploadedFile === null} 
                      className={`blue-btn ${uploadedFile === null ? 'disabled' : ''}`}
                      type="submit"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}
            </div>
          </div>) : null
        }

        { formLoading && <Loader/> }
        
        {showConfirmationPopup && (
            <MessageSendingData
                messageText={confirmationPopupText}
                setClosePopup={() => setShowConfirmationPopup(false)}
            />
        )}
      </>
  )
}

export default VoluumKelkooIntegration;
 